import { Outlet } from 'react-router-dom';
import Layout from '../layout/Layout';
import useProfile from '@hooks/useProfile';
import Loader from '@components/loader/Loader';
import { ProfileContext } from '@contexts';
import ErrorDialog from '@components/modals/ErrorDialog';
import { useEffect, useState } from 'react';
import { ErrorDialogContext } from '@contexts/ErrorDialogContext';
import { useLocation } from 'react-router';

const Main = () => {
  const { isFetching, data, refetch } = useProfile();
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const location = useLocation();
  const [isInit, setIsInit] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if(!isInit) {
        setIsInit(true);
      }
    }, 3000);
  }, []);

  useEffect(() => {
    if(location?.pathname === '/profile' && isInit) {
      refetch();
    }
  }, [location?.pathname]);

  return (
    <ProfileContext.Provider value={data}>
      <ErrorDialogContext.Provider
        value={{ setOpenErrorDialog, setErrorMessage }}
      >
        <Layout>{isFetching ? <Loader isShowLoader /> : <Outlet />}</Layout>
        <ErrorDialog
          open={openErrorDialog}
          handleClose={() => setOpenErrorDialog(false)}
          message={errorMessage}
        />
      </ErrorDialogContext.Provider>
    </ProfileContext.Provider>
  );
};

export default Main;
